import React from 'react';
import TextArea from '../common/TextArea';

const Page6Feedback = ({ 
  serviceFeedback,
  updateServiceFeedback,
  handlePrevious,
  handleNext 
}) => {
  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>What service level improvement (for our physician services) could we make to enhance our offering?</label>
          <TextArea
            value={serviceFeedback.physicianConsult}
            onChange={(value) => updateServiceFeedback('physicianConsult', value)}
            placeholder="Please provide your feedback here..."
          />
        </div>

        <div className="question-item full-width">
          <label>What service level improvement (for our nursing services) could we make to enhance our offering?</label>
          <TextArea
            value={serviceFeedback.nursingServices}
            onChange={(value) => updateServiceFeedback('nursingServices', value)}
            placeholder="Please provide your feedback here..."
          />
        </div>

        <div className="question-item full-width">
          <label>Please share issues or concerns that has impacted your experience and critical care of patients.</label>
          <TextArea
            value={serviceFeedback.concerns}
            onChange={(value) => updateServiceFeedback('concerns', value)}
            placeholder="Please share your concerns here..."
          />
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={!serviceFeedback.physicianConsult.trim() || 
                   !serviceFeedback.nursingServices.trim()}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page6Feedback;
